import Vue from 'vue'
export default {
  unload ($event) {
    let confirmationMessage = "\o/";
    $event.returnValue = confirmationMessage
    return confirmationMessage
  },
  cloneData (original) {
    const data = JSON.parse(JSON.stringify(original))
    return data instanceof Array ? Object.assign([], data)
      : data instanceof Object ? Object.assign({}, data)
      : data
  },
  deepCopy (original) {
    let data = {}
    if (original instanceof Object) {
      Object.keys(original).map(key => {
        data[key] = JSON.parse(JSON.stringify(original[key]))
      })
    } else {
      data = this.cloneData(original)
    }
    return data
  },
  isFileExist (obj) {
    return obj && obj.url ? true : false
  },
  getFileExist (obj) {
    if (obj && obj.constructor === String) {
      obj = { url: Vue.prototype.$hostURL + obj }
    }
    return obj && obj.url ? obj.url : ''
  },
  getFileUrl (path) {
    return Vue.prototype.$hostURL + path
  },
  getFileExistOld (obj) {
    return obj && obj.length>0 ? obj[0].url : this.getFileExist(obj)
  },
  getFileList (obj) {
    return this.isFileExist(obj) ? [obj] : []
  },
  getImgOrientation (file, obj) {
    let img = new Image()
    const vm = this
    img.addEventListener("load", function () {
      file.orientation = img.width > img.height ? 'landscape' : 'portrait'
      obj = file
    })
    img.src = file.url
  },
  chunk (data, chunk_size) {
    if ( !data.length ) {
      return []
    }
    return [ data.slice( 0, chunk_size ) ].concat(this.chunk(data.slice(chunk_size), chunk_size))
  },
  getTextCroped(txt, limit, tail) {
    return txt ? this.getStripHtml(txt).substr(0, limit) + tail : ''
  },
  getStripHtml (txt) {
    let div = document.createElement('div')
    div.innerHTML = txt
    return div.textContent || div.innerText || ''
  },
  dataToJsonParse (data) {
    return data ? JSON.parse(data) : data
  },
  getMathAbs (v) {
    return Math.abs(v)
  },
  removeFroalaAlertText (text) {
    const froalaText = vm.$store.getters.getFroalaAlertText
    return text ? text.replace(froalaText, '') : ''
  },
  // getLastMonthDate (chart) {
  //   const dt = new Date()
  //   const rtn = chart === 'top100' || chart === 'check100'
  //     ? `${dt.getFullYear()}.${dt.getMonth()+1}.${dt.getDate()}`
  //     : `${dt.getFullYear()}.${dt.getMonth()}.15`
  //   return rtn
  // },
  gotoCategory (idx) {
    vm.$router.push(`/news/cate/${idx}`)
  },
  convertOrdinalNumber (n) {
    n = parseInt(n, 10)
    const suffix = ['th', 'st', 'nd', 'rd']
    const mod100 = n % 100
    return (suffix[(mod100-20)%10] || suffix[mod100] || suffix[0])
  },
  async setLanguageCookie(lang) {
    if (this.$cookies.isKey('lang')) await this.$cookies.remove("lang", '/', this.getCookieDomain)
    await this.$cookies.set('lang', lang, '365d', '/', this.getCookieDomain)
  },
  async gotoSitePage(lang) {  // jp 버전
    const toLang = lang.toString().toLowerCase()
    const dir = (lang !== 'KR' ? '/' + toLang : '')
    const domain = window.location.origin + dir
    const routeName = this.$route.name
    const routeParams = this.$route.params
    const baseAction = this.findBaseActionInSiblings(routeName)
    const idx = this.$route.params.idx
    let url
    if (routeName.slice(0, 13) !== 'GallerySeries' && Object.keys(routeParams).length > 0 && idx && baseAction) {
      const krApiURL = Vue.prototype.$apiURL.replace('/en', '')
      // const krApiURL = 'http://localhost:8280/v1'
      const params = {
        params: {
          base_action: baseAction,
          lang_code: toLang,
          mapping_idx: idx,
          from_lang_code: 'en'
        }
      }
      const rtnIdx = await this.$axios.get(krApiURL + '/multi/lang/search', params).then(rs => {
        if (rs.data.mapping_idx) {
          return toLang === 'kr' ? rs.data.model_idx : rs.data.mapping_idx
        }
        return null
      })
      if (rtnIdx) {
        const path = this.$route.matched[0].path
        url = domain + path.replace(':idx', rtnIdx)
      } else {

        //notice - 주석을 풀면 사용자가 이동을 선택할 수 있음
        // const langArr = {
        //   kr: '한국어',
        //   jp: '일본어',
        //   en: '영어',
        // }
        // if (!confirm(`선택한 언어로는 동일한 컨텐츠가 없습니다. ${langArr[toLang]} 홈으로 이동할까요?`)) {
        //   return
        // }
      }
    } else {
      url = domain + this.$route.path
    }
    // console.log(url ? url : domain + '/home')
    window.location = url ? url : domain + '/home'
  },
  async gotoSite(lang) {
    await this.setLanguageCookie(lang)
    await this.gotoSitePage(lang)
  },
  findBaseActionInSiblings(routeName) {
    const parent = this.$parent
    if (!parent) return null
    const target = this.getAccess === 'mobile' ? parent.$children[0].$children : parent.$children
    const filteredChildren = target.find(child => child.getCurrentComponentName === routeName)
    return filteredChildren ? filteredChildren.baseAction : null
  }
}
